<template >
  <section id="main-container">
    <v-layout>
      <KitchenSink></KitchenSink>
    </v-layout>
  </section>
</template>

<script>
import KitchenSink from "@/components/kitchen-sink/KitchenSink.vue"

export default {
  name: "app3",
  components: {
    KitchenSink
  },
  data: () => ({}),
  methods: {},
  created: function() {}
}
</script>
